import { render } from "./ModalImagesSlider.vue?vue&type=template&id=0bc331cd"
import script from "./ModalImagesSlider.vue?vue&type=script&lang=js"
export * from "./ModalImagesSlider.vue?vue&type=script&lang=js"

import "./ModalImagesSlider.vue?vue&type=style&index=0&id=0bc331cd&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"webpack-assets/vue/templates/chat/parts/ModalImagesSlider.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0bc331cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0bc331cd', __exports__)) {
    api.reload('0bc331cd', __exports__)
  }
  
  module.hot.accept("./ModalImagesSlider.vue?vue&type=template&id=0bc331cd", () => {
    api.rerender('0bc331cd', render)
  })

}


export default __exports__